'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_ImageEditor$Backend$$anon$1(obj$5, outer) {
  this.amn = null;
  this.aK3 = null;
  this.amn = obj$5;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.aK3 = outer;
}
export { $c_Lmealorama_components_ImageEditor$Backend$$anon$1 as $c_Lmealorama_components_ImageEditor$Backend$$anon$1 };
$p = $c_Lmealorama_components_ImageEditor$Backend$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_ImageEditor$Backend$$anon$1;
/** @constructor */
function $h_Lmealorama_components_ImageEditor$Backend$$anon$1() {
}
export { $h_Lmealorama_components_ImageEditor$Backend$$anon$1 as $h_Lmealorama_components_ImageEditor$Backend$$anon$1 };
$h_Lmealorama_components_ImageEditor$Backend$$anon$1.prototype = $p;
$p.vo = (function(b) {
  var obj$1 = this.amn;
  var array = Object.keys(obj$1);
  var len = (array.length | 0);
  var i = 0;
  while ((i < len)) {
    var x0 = array[i];
    b.aab().a7(x0, obj$1[x0]);
    i = ((1 + i) | 0);
  }
});
var $d_Lmealorama_components_ImageEditor$Backend$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_ImageEditor$Backend$$anon$1, "mealorama.components.ImageEditor$Backend$$anon$1", ({
  Hk: 1,
  aV: 1
}));
export { $d_Lmealorama_components_ImageEditor$Backend$$anon$1 as $d_Lmealorama_components_ImageEditor$Backend$$anon$1 };
//# sourceMappingURL=mealorama.components.-Image-Editor$-Backend$$anon$1.js.map
